import api from './api';

export interface ProductInventoryDisplay {
  _id: string;
  productId?: string; // معرف المنتج الأصلي (في حالة المتغيرات)
  name: string;
  mainImage?: string;
  productType?: string;
  attributes?: { [key: string]: string };
  inventory: {
    warehouseId: string;
    warehouseName: string;
    quantity: number;
    reservedQuantity: number;
    minQuantity: number;
  }[];
  relatedProducts?: ProductInventoryDisplay[];
}

export interface InventoryDisplayFilters {
  productType?: string;
  attributes?: { [key: string]: string };
  search?: string;
  warehouseId?: string;
  page?: number;
  limit?: number;
}

export interface Warehouse {
  _id: string;
  name: string;
  location?: string;
}

export interface ProductAttribute {
  _id: string;
  name: string;
  values: string[];
}

// جلب المنتجات مع كميات المخزون حسب الفلاتر
export const getProductsInventoryDisplay = async (
  filters: InventoryDisplayFilters
): Promise<{
  success: boolean;
  products: ProductInventoryDisplay[];
  total: number;
  page: number;
  totalPages: number;
}> => {
  try {
    const params = new URLSearchParams();
    
    if (filters.productType) params.append('productType', filters.productType);
    if (filters.search) params.append('search', filters.search);
    if (filters.warehouseId) params.append('warehouseId', filters.warehouseId);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    // إضافة الخصائص كمعاملات منفصلة
    if (filters.attributes) {
      Object.entries(filters.attributes).forEach(([key, value]) => {
        if (value) {
          params.append(`attr_${key}`, value);
        }
      });
    }

    const response = await api.get(`/inventory-display/display?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching products inventory display:', error);
    throw error;
  }
};

// جلب المستودعات للفلتر - يستخدم endpoint خاص بصفحة عرض المخزون
export const getWarehousesForInventoryDisplay = async (): Promise<Warehouse[]> => {
  try {
    const response = await api.get('/inventory-display/warehouses');
    return response.data.warehouses || [];
  } catch (error) {
    console.error('Error fetching warehouses for inventory display:', error);
    throw error;
  }
};

// جلب خصائص المنتج للفلتر - يستخدم endpoint خاص بصفحة عرض المخزون
export const getProductAttributesForInventoryDisplay = async (): Promise<ProductAttribute[]> => {
  try {
    const response = await api.get('/inventory-display/attributes');
    return response.data || [];
  } catch (error) {
    console.error('Error fetching product attributes for inventory display:', error);
    throw error;
  }
};

// جلب أنواع المنتجات للفلتر - يستخدم endpoint خاص بصفحة عرض المخزون
export const getProductTypesForInventoryDisplay = async (): Promise<string[]> => {
  try {
    const response = await api.get('/inventory-display/product-types');
    return response.data.types || [];
  } catch (error) {
    console.error('Error fetching product types for inventory display:', error);
    throw error;
  }
};

// جلب المنتجات المرتبطة مع كميات المخزون
export const getRelatedProductsInventory = async (
  productId: string
): Promise<{
  success: boolean;
  relatedProducts: ProductInventoryDisplay[];
}> => {
  try {
    const response = await api.get(`/inventory-display/display/${productId}/related`);
    return response.data;
  } catch (error) {
    console.error('Error fetching related products inventory:', error);
    throw error;
  }
};
